import { Link } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Metric, formatCurrency } from "@odingard/design-system";
import { ErrorState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../../lib/auth";
import { useAsync } from "../../lib/useAsync";
import { proposalApi } from "../../lib/api";
import { DemoModeBanner, LiveModeBadge } from "../../components/ProposalGrounded";

export function PaiDashboard() {
  const { activeOrg } = useAuth();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => proposalApi.dashboard(orgId), [orgId]);
  const d = state.data?.data;
  const coveragePct = d ? Math.round(d.complianceCoverage?.coveragePct ?? 0) : 0;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>Proposal AI</h1>
          <p>Pipeline health, deadlines, and AI activity.</p>
        </div>
        <div className="ods-row">
          <Link to="/studio/proposal-ai/opportunities">
            <Button size="sm">Opportunities</Button>
          </Link>
          <Link to="/studio/proposal-ai/analytics">
            <Button size="sm" variant="secondary">
              Analytics
            </Button>
          </Link>
        </div>
      </div>

      <DemoModeBanner show={state.data?.demoMode ?? false} />
      <div style={{ marginBottom: "var(--ods-space-3)" }}>
        <LiveModeBadge demoMode={state.data?.demoMode ?? false} />
      </div>
      {state.loading && <LoadingState label="Loading dashboard…" />}
      {state.error && <ErrorState description={state.error.message} onRetry={state.reload} />}
      {d && (
        <>
          <div className="metric-grid">
            <div className="metric-card">
              <Metric value={d.openOpportunities ?? 0} label="Open pursuits" />
            </div>
            <div className="metric-card">
              <Metric value={formatCurrency(d.pipelineValue ?? 0, "usd")} label="Pipeline value" />
            </div>
            <div className="metric-card">
              <Metric value={d.bidNoBidPending ?? 0} label="Bid decisions pending" tone="var(--ods-color-warning)" />
            </div>
            <div className="metric-card">
              <Metric value={d.upcomingDeadlines?.length ?? 0} label="Upcoming deadlines" tone="var(--ods-color-warning)" />
            </div>
          </div>
          <div className="metric-grid">
            <div className="metric-card">
              <Metric value={`${coveragePct}%`} label="Compliance coverage" />
            </div>
            <div className="metric-card">
              <Metric value={d.complianceCoverage?.totalRows ?? 0} label="Requirements tracked" />
            </div>
            <div className="metric-card">
              <Metric value={d.criticalGaps ?? 0} label="Critical gaps" tone="var(--ods-color-warning)" />
            </div>
            <div className="metric-card">
              <Metric value={d.recentSolicitations?.length ?? 0} label="Recent solicitations" />
            </div>
          </div>

          <Card>
            <CardHeader title="Get started" />
            <CardBody>
              <div className="ods-stack">
                <p style={{ margin: 0, color: "var(--ods-color-muted)" }}>
                  Create or import an opportunity, upload its solicitation, and Proposal AI shreds requirements into a
                  grounded compliance matrix.
                </p>
                <div className="ods-row">
                  <Link to="/studio/proposal-ai/opportunities">
                    <Button size="sm">Go to pipeline</Button>
                  </Link>
                  <Link to="/studio/proposal-ai/compliance">
                    <Button size="sm" variant="secondary">
                      Compliance center
                    </Button>
                  </Link>
                </div>
              </div>
            </CardBody>
          </Card>
        </>
      )}
    </>
  );
}
